<script>
/* global _ */
import { mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";
import clientConfig from '/src/config/client.js';

export default {
  data () {
    return {
      clientConfig
    };
  },
  computed: {
    ...mapFields([
      'ui.showForeground',
      'ui.isAnimating',
    ]),
    ...mapGetters([
      'isOnPage',
      'currentPage',
    ]),
    isOnWelcomePage: function () {
      return this.isOnPage('welcome');
    },
    showToggleSceneButton: function () {
      const pagesHiddenOn = ['welcome', 'loading'];
      const isOnHiddenPage = _.includes(pagesHiddenOn, this.currentPage);

      return this.isAnimating === false && isOnHiddenPage === false;
    },
  },
};
</script>

<template>
  <header class='header'>
    <div :class="['header_content', isOnWelcomePage ? 'header_content--welcome' : '']">
      <slot>
        <img
          class='lt-logo'
          :src="require('@/assets/' + clientConfig.content.welcome.logoUrl + '')"
          alt="Company logo"
        />
      </slot>
      <div class="button-container">
        <button
          :class="['toggle-scene', showForeground ? 'toggle-scene--active' : '']"
          @click="showForeground = !showForeground"
          v-show='showToggleSceneButton'
        >
          <p>Toggle scene</p>
        </button>
      </div>
    </div>
  </header>
</template>
